/* filter-bar.js — JustForFunFlags collection filter bar
   ES5-compatible, no dependencies */

(function () {
  'use strict';

  /* ── Filter Data ─────────────────────────────────────────── */

  var PRODUCT_TYPES = [
    { label: 'Garden Flags',    handle: 'garden-flags' },
    { label: 'House Flags',     handle: 'house-flags' },
    { label: 'Banner Flags',    handle: 'america-forever-banner-flags' },
    { label: 'Mailbox Covers',  handle: 'mailbox-covers' },
    { label: 'Doormats',        handle: 'doormats' },
    { label: 'Yard Signs',      handle: 'yard-signs' },
    { label: 'Windsocks',       handle: 'windsocks-windsocks' },
    { label: 'Door Decor',      handle: 'door-decor-accessories' },
    { label: 'Accessories',     handle: 'accessories' }
  ];
  var TYPE_HANDLES = PRODUCT_TYPES.map(function (t) { return t.handle; });

  var VENDORS = [
    { label: 'America Forever', value: 'America Forever', tag: 'america-forever' },
    { label: 'Carson',          value: 'Carson',          tag: 'carson' },
    { label: 'Custom Decor',    value: 'Custom Decor',    tag: 'custom-decor' },
    { label: 'Evergreen',       value: 'Evergreen',       tag: 'evergreen' },
    { label: 'In the Breeze',   value: 'In the Breeze',   tag: 'in-the-breeze' },
    { label: 'Studio M',        value: 'Studio M',        tag: 'studio-m' },
    { label: 'Premier',         value: 'Premier',         tag: 'premier' }
  ];
  var VENDOR_TAGS = VENDORS.map(function (v) { return v.tag; });

  var SEASONS = [
    { label: 'Spring', tag: 'spring' },
    { label: 'Summer', tag: 'summer' },
    { label: 'Fall',   tag: 'fall' },
    { label: 'Winter', tag: 'winter' }
  ];
  var SEASON_TAGS = ['spring', 'summer', 'fall', 'winter'];

  var HOLIDAYS = [
    { label: "Valentine's Day",  tag: 'valentines-day',  seasons: ['winter'] },
    { label: 'Mardi Gras',       tag: 'mardi-gras',      seasons: ['winter', 'spring'] },
    { label: 'Ash Wednesday',    tag: 'ash-wednesday',   seasons: ['winter', 'spring'] },
    { label: 'Lent',             tag: 'lent',            seasons: ['winter', 'spring'] },
    { label: "St. Patrick's Day",tag: 'st-patricks-day', seasons: ['spring'] },
    { label: 'Palm Sunday',      tag: 'palm-sunday',     seasons: ['spring'] },
    { label: 'Passover',         tag: 'passover',        seasons: ['spring'] },
    { label: 'Easter',           tag: 'easter',          seasons: ['spring'] },
    { label: "Mother's Day",     tag: 'mothers-day',     seasons: ['spring'] },
    { label: "Father's Day",     tag: 'fathers-day',     seasons: ['summer'] },
    { label: 'Memorial Day',     tag: 'memorial-day',    seasons: ['summer'] },
    { label: '4th of July',      tag: '4th-of-july',     seasons: ['summer'] },
    { label: 'Halloween',        tag: 'halloween',       seasons: ['fall'] },
    { label: 'Thanksgiving',     tag: 'thanksgiving',    seasons: ['fall'] },
    { label: 'Christmas',        tag: 'christmas',       seasons: ['winter'] },
    { label: 'Hanukkah',         tag: 'hanukkah',        seasons: ['winter'] },
    { label: 'Kwanzaa',          tag: 'kwanzaa',         seasons: ['winter'] },
    { label: 'New Year',         tag: 'new-year',        seasons: ['winter'] }
  ];
  var HOLIDAY_TAGS = HOLIDAYS.map(function (h) { return h.tag; });

  var OCCASIONS = [
    { label: 'Birthday',          tag: 'birthday' },
    { label: 'Wedding',           tag: 'wedding' },
    { label: 'Anniversary',       tag: 'anniversary' },
    { label: 'Graduation',        tag: 'graduation' },
    { label: 'Baby & Kids',       tag: 'baby-and-kids' },
    { label: 'Family',            tag: 'family' },
    { label: 'Friends',           tag: 'friends' },
    { label: 'Grandparents',      tag: 'grandparents' },
    { label: 'Cemetery/Memorial', tag: 'cemetery' },
    { label: 'Back to School',    tag: 'back-to-school' },
    { label: 'First Communion',   tag: 'first-communion' },
    { label: 'Baptism',           tag: 'baptism' }
  ];
  var OCCASION_TAGS = OCCASIONS.map(function (o) { return o.tag; });

  var THEMES = [
    {
      group: 'Birds', groupTag: 'birds',
      items: [
        { label: 'Cardinals',    tag: 'cardinals' },
        { label: 'Bluebirds',    tag: 'bluebirds' },
        { label: 'Chickadees',   tag: 'chickadees' },
        { label: 'Eagles',       tag: 'eagles' },
        { label: 'Goldfinches',  tag: 'goldfinches' },
        { label: 'Hummingbirds', tag: 'hummingbirds' },
        { label: 'Owls',         tag: 'owls' },
        { label: 'Robins',       tag: 'robins' },
        { label: 'Roosters',     tag: 'roosters' },
        { label: 'Flamingos',    tag: 'flamingos' },
        { label: 'Parrots',      tag: 'parrots' },
        { label: 'Penguins',     tag: 'penguins' },
        { label: 'Seagulls',     tag: 'seagulls' }
      ]
    },
    {
      group: 'Flowers', groupTag: 'flowers',
      items: [
        { label: 'Daisies',    tag: 'daisies' },
        { label: 'Hydrangeas', tag: 'hydrangeas' },
        { label: 'Lavender',   tag: 'lavender' },
        { label: 'Roses',      tag: 'roses' },
        { label: 'Sunflowers', tag: 'sunflowers' },
        { label: 'Tulips',     tag: 'tulips' },
        { label: 'Poppies',    tag: 'poppies' },
        { label: 'Geraniums',  tag: 'geraniums' },
        { label: 'Lilacs',     tag: 'lilacs' },
        { label: 'Magnolias',  tag: 'magnolias' },
        { label: 'Peonies',    tag: 'peonies' }
      ]
    },
    {
      group: 'Butterflies & Insects', groupTag: 'butterflies-insects',
      items: [
        { label: 'Butterflies', tag: 'butterflies' },
        { label: 'Bees',        tag: 'bees' },
        { label: 'Dragonflies', tag: 'dragonflies' },
        { label: 'Ladybugs',    tag: 'ladybugs' },
        { label: 'Fireflies',   tag: 'fireflies' }
      ]
    },
    {
      group: 'Pets & Animals', groupTag: 'pets-animals',
      items: [
        { label: 'Dogs',         tag: 'dogs' },
        { label: 'Cats',         tag: 'cats' },
        { label: 'Bunnies',      tag: 'bunnies' },
        { label: 'Farm Animals', tag: 'farm-animals' },
        { label: 'Wildlife',     tag: 'wildlife' },
        { label: 'Aquatic Life', tag: 'aquatic-life' }
      ]
    },
    {
      group: 'Gardens', groupTag: 'gardens',
      items: [
        { label: 'Birdhouses',    tag: 'birdhouses' },
        { label: 'Garden Gnomes', tag: 'garden-gnomes' },
        { label: 'Watering Cans', tag: 'watering-cans' },
        { label: 'Potted Floral', tag: 'potted-floral' }
      ]
    },
    { group: 'Welcome',      groupTag: 'welcome-flags',  items: [] },
    {
      group: 'Love & Happiness', groupTag: 'love-happiness',
      items: [
        { label: 'Home Sweet Home', tag: 'home-sweet-home' },
        { label: 'Hello',           tag: 'hello' }
      ]
    },
    {
      group: 'Religious', groupTag: 'religious',
      items: [
        { label: 'Angels',          tag: 'angels' },
        { label: 'Crosses',         tag: 'crosses' },
        { label: 'Inspirational',   tag: 'inspirational' },
        { label: 'Bible Scriptures',tag: 'bible-scriptures' },
        { label: 'Memorial',        tag: 'memorial' }
      ]
    },
    {
      group: 'Patriotic', groupTag: 'patriotic',
      items: [
        { label: 'American Flags',     tag: 'american-flags' },
        { label: 'God Bless America',  tag: 'god-bless-america' },
        { label: 'Liberty & Freedom',  tag: 'liberty-freedom' },
        { label: 'Support Our Troops', tag: 'support-our-troops' }
      ]
    },
    {
      group: 'Beaches & Nautical', groupTag: 'beaches-nautical',
      items: [
        { label: 'Beach',       tag: 'beach' },
        { label: 'Lighthouses', tag: 'lighthouses' },
        { label: 'Nautical',    tag: 'nautical' },
        { label: 'Tropical',    tag: 'tropical' }
      ]
    },
    {
      group: 'Country Living', groupTag: 'country-living',
      items: [
        { label: 'Farm',       tag: 'farm' },
        { label: 'Red Truck',  tag: 'red-truck' },
        { label: 'Scarecrows', tag: 'scarecrows' },
        { label: 'Western',    tag: 'western' }
      ]
    },
    {
      group: 'Food & Wine', groupTag: 'food-wine',
      items: [
        { label: 'BBQ',          tag: 'bbq' },
        { label: 'Coffee',       tag: 'coffee' },
        { label: 'Wine & Drinks',tag: 'wine-drinks' },
        { label: 'Lemonade',     tag: 'lemonade' },
        { label: 'Watermelon',   tag: 'watermelon' }
      ]
    },
    {
      group: 'Great Outdoors', groupTag: 'great-outdoors',
      items: [
        { label: 'Camping', tag: 'camping' },
        { label: 'Fishing', tag: 'fishing' },
        { label: 'Lakes',   tag: 'lakes' }
      ]
    },
    {
      group: 'First Responders', groupTag: 'first-responders',
      items: [
        { label: 'Firefighters',    tag: 'fire-fighter' },
        { label: 'Police Officers', tag: 'police-officer' }
      ]
    },
    { group: 'Humor',       groupTag: 'humor',       items: [] },
    { group: 'Monogrammed', groupTag: 'monogrammed', items: [] },
    {
      group: 'Sports', groupTag: 'sports',
      items: [
        { label: 'Bicycles',        tag: 'bicycles' },
        { label: 'Golf',            tag: 'golf' },
        { label: 'Hot Air Balloons',tag: 'hot-air-balloons' }
      ]
    },
    {
      group: 'Fantasy', groupTag: 'fantasy',
      items: [
        { label: 'Fairies',  tag: 'fairies' },
        { label: 'Mermaids', tag: 'mermaids' }
      ]
    },
    {
      group: 'Regional', groupTag: 'regional',
      items: [
        { label: 'California', tag: 'california' },
        { label: 'Florida',    tag: 'florida' },
        { label: 'New York',   tag: 'new-york' },
        { label: 'Texas',      tag: 'texas' }
      ]
    }
  ];

  var THEME_GROUP_TAGS = THEMES.map(function (t) { return t.groupTag; });
  var THEME_SUB_TAGS = [];
  THEMES.forEach(function (t) {
    t.items.forEach(function (i) { THEME_SUB_TAGS.push(i.tag); });
  });

var FEATURES = [
  { label: 'Double-Sided',      tag: 'double-sided' },
  { label: 'Reversible',        tag: 'reversible' },
  { label: 'PremierSoft',       tag: 'premiersoft' },
  { label: 'Suede Reflections', tag: 'suedereflections' },
  { label: 'GlitterTrends',     tag: 'glittertrends' },
  { label: 'Printed in USA',    tag: 'printed-in-usa' },
  { label: 'Eco-Friendly',      tag: 'eco-friendly' }
];
  var FEATURE_TAGS = FEATURES.map(function (f) { return f.tag; });

  var SUB_FILTERS = {
    'garden-flags': [
      {
        label: 'Material',
        options: [
          { label: 'Printed',       tag: 'printed' },
          { label: 'Applique',      tag: 'applique' },
          { label: 'Burlap',        tag: 'burlap' },
          { label: 'Linen',         tag: 'linen' },
          { label: 'Lustre',        tag: 'lustre' },
          { label: 'Moire',         tag: 'moire' },
          { label: 'Foil Accent',   tag: 'foil-accent' },
          { label: 'Metal',         tag: 'metal' },
          { label: 'Satin',         tag: 'satin' }
        ]
      },
      {
        label: 'Size',
        options: [
          { label: 'Standard 12.5×18', tag: 'standard-garden' },
          { label: 'Mini Garden',      tag: 'mini-garden' },
          { label: 'Long Garden',      tag: 'long-garden' }
        ]
      }
    ],
    'house-flags': [
      {
        label: 'Material',
        options: [
          { label: 'Printed',  tag: 'printed' },
          { label: 'Applique', tag: 'applique' },
          { label: 'Burlap',   tag: 'burlap' },
          { label: 'Lustre',   tag: 'lustre' },
          { label: 'Moire',    tag: 'moire' },
          { label: 'Linen',    tag: 'linen' }
        ]
      }
    ],
    'mailbox-covers': [
      {
        label: 'Size',
        options: [
          { label: 'Regular', tag: 'regular-mailbox' },
          { label: 'Large',   tag: 'large-mailbox' }
        ]
      }
    ],
    'doormats': [
      {
        label: 'Size',
        options: [
          { label: 'Regular', tag: 'regular-doormat' },
          { label: 'Mini',    tag: 'mini-doormat' }
        ]
      },
      {
        label: 'Material',
        options: [
          { label: 'Coir', tag: 'coir' }
        ]
      }
    ]
  };

  var MATERIAL_OPTS = [];
  var SIZE_OPTS     = [];
  (function () {
    for (var h in SUB_FILTERS) {
      var groups = SUB_FILTERS[h];
      for (var gi = 0; gi < groups.length; gi++) {
        var destO = (groups[gi].label === 'Size') ? SIZE_OPTS : MATERIAL_OPTS;
        for (var oi = 0; oi < groups[gi].options.length; oi++) {
          var o = groups[gi].options[oi];
          var dup = false;
          for (var di = 0; di < destO.length; di++) { if (destO[di].tag === o.tag) { dup = true; break; } }
          if (!dup) destO.push({ label: o.label, tag: o.tag });
        }
      }
    }
  })();
  var MATERIAL_TAGS = MATERIAL_OPTS.map(function (o) { return o.tag; });
  var SIZE_TAGS     = SIZE_OPTS.map(function (o) { return o.tag; });

  var cfg = window.FilterBarConfig || {};
  var collectionHandle = cfg.collectionHandle || 'all';
  var currentTags      = cfg.currentTags || [];
  var countsUrl        = cfg.countsUrl || '';
  var counts           = null;
  var colTagsReady     = false;
  var colVendorsReady  = false;

  if (!Array.isArray(currentTags)) currentTags = [];
  currentTags = currentTags.map(function (t) { return slugify(t); });

  var activeTags    = currentTags.slice();

  var activeVendor    = null;
  var activeVendorTag = null;
  for (var _vi = 0; _vi < VENDORS.length; _vi++) {
    if (indexOf(activeTags, VENDORS[_vi].tag) !== -1) {
      activeVendor    = VENDORS[_vi].value;
      activeVendorTag = VENDORS[_vi].tag;
      break;
    }
  }
  var activeType    = getUrlParam('type');
  var displayHandle = (activeType && indexOf(TYPE_HANDLES, activeType) !== -1)
                      ? activeType : collectionHandle;
  var activeTagParams = [];
  (function () {
    var raw = getUrlParam('tag');
    if (!raw) return;
    var parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var t = slugify(parts[i]);
      if (t && isKnownTag(t) && indexOf(activeTags, t) === -1 && indexOf(activeTagParams, t) === -1) {
        activeTagParams.push(t);
      }
    }
  })();

  function isKnownTag(t) {
    return indexOf(SEASON_TAGS, t)      !== -1 || indexOf(HOLIDAY_TAGS, t)     !== -1 ||
           indexOf(OCCASION_TAGS, t)    !== -1 || indexOf(THEME_GROUP_TAGS, t) !== -1 ||
           indexOf(THEME_SUB_TAGS, t)   !== -1 || indexOf(FEATURE_TAGS, t)     !== -1 ||
           indexOf(MATERIAL_TAGS, t)    !== -1 || indexOf(SIZE_TAGS, t)        !== -1 ||
           indexOf(VENDOR_TAGS, t)      !== -1;
  }

  function tagParamActive(tag) { return indexOf(activeTagParams, tag) !== -1; }

  var bar, mainRow, subRow, pillsRow, pillsEl, clearBtn;

  function init() {
    bar        = document.getElementById('FilterBar');
    mainRow    = document.getElementById('FilterBarMainRow');
    subRow     = document.getElementById('FilterBarSubRow');
    pillsRow   = document.getElementById('FilterBarPillsRow');
    pillsEl    = document.getElementById('FilterBarPills');
    clearBtn   = document.getElementById('FilterBarClear');

    if (!bar) return;

    initDropdownTriggers();
    updateButtonStates();
    updateClearBtn();
    renderPills();
    renderSubFilters();
    patchPaginationLinks();
    initStickyObserver();
    loadCounts();

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onDocKeydown);
    window.addEventListener('scroll', closeAllDropdowns, { passive: true });
  }

  function loadCounts() {
    if (!countsUrl) return;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', countsUrl, true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          counts = JSON.parse(xhr.responseText);

          var col = counts[collectionHandle];
          if (col && col.tags) {
            for (var t in col.tags) {
              if (col.tags[t] > 0) { colTagsReady = true; break; }
            }
          }
          if (col && col.vendors) {
            for (var v in col.vendors) {
              if (col.vendors[v] > 0) { colVendorsReady = true; break; }
            }
          }

          var openDds = document.querySelectorAll('.filter-bar-dropdown:not([hidden])');
          for (var i = 0; i < openDds.length; i++) {
            var id = openDds[i].id.replace('fb-dropdown-', '');
            buildDropdown(id);
          }

          /* Hide any whole filter button whose dropdown would now be
             completely empty (every option zero-count, none active). */
          updateAllGroupVisibility();
        } catch (e) { /* malformed JSON — degrade gracefully */ }
      }
    };
    xhr.send();
  }

  function getTagBtnId(tag) {
    if (!tag) return null;
    if (indexOf(SEASON_TAGS, tag) !== -1)   return 'season';
    if (indexOf(HOLIDAY_TAGS, tag) !== -1)  return 'holiday';
    if (indexOf(OCCASION_TAGS, tag) !== -1) return 'occasion';
    if (indexOf(THEME_GROUP_TAGS, tag) !== -1 || indexOf(THEME_SUB_TAGS, tag) !== -1) return 'theme';
    if (indexOf(FEATURE_TAGS, tag) !== -1)  return 'features';
    return null;
  }

  function lookupCount(obj, key) {
    if (!obj) return null;
    if (typeof obj[key] === 'number') return obj[key];
    var lower = key.toLowerCase();
    for (var k in obj) {
      if (k.toLowerCase() === lower && typeof obj[k] === 'number') return obj[k];
    }
    return null;
  }

  function lookupObj(obj, key) {
    if (!obj) return null;
    var direct = obj[key];
    if (direct !== null && direct !== undefined && typeof direct === 'object') return direct;
    var lower = String(key).toLowerCase();
    for (var k in obj) {
      if (k.toLowerCase() === lower && obj[k] !== null && typeof obj[k] === 'object') return obj[k];
    }
    return null;
  }

  function indexCol() {
    if (!counts) return null;
    if (displayHandle && counts[displayHandle] && counts[displayHandle].index) {
      return counts[displayHandle];
    }
    if (counts[collectionHandle] && counts[collectionHandle].index) {
      return counts[collectionHandle];
    }
    return null;
  }

  function getBaseTags() {
    var b = activeTags.slice();
    for (var i = 0; i < activeTagParams.length; i++) {
      if (indexOf(b, activeTagParams[i]) === -1) b.push(activeTagParams[i]);
    }
    return b;
  }

  function comboCount(keys) {
    var col = indexCol();
    if (!col || !col.index) return null;
    if (!keys || keys.length === 0) {
      return (typeof col.totalProducts === 'number') ? col.totalProducts : null;
    }

    var lists = [];
    for (var i = 0; i < keys.length; i++) {
      var l = col.index[keys[i]];
      if (!l || !l.length) return 0;
      lists.push(l);
    }

    lists.sort(function (a, b) { return a.length - b.length; });
    var setObj = {};
    var first = lists[0];
    for (var j = 0; j < first.length; j++) setObj[first[j]] = true;

    for (var li = 1; li < lists.length; li++) {
      var arr  = lists[li];
      var next = {};
      for (var k = 0; k < arr.length; k++) {
        if (setObj[arr[k]]) next[arr[k]] = true;
      }
      setObj = next;
    }

    var cnt = 0;
    for (var key in setObj) { if (setObj.hasOwnProperty(key)) cnt++; }
    return cnt;
  }

  function categoryOf(slug) {
    if (indexOf(VENDOR_TAGS, slug) !== -1)   return 'vendor';
    if (indexOf(SEASON_TAGS, slug) !== -1)   return 'season';
    if (indexOf(HOLIDAY_TAGS, slug) !== -1)  return 'holiday';
    if (indexOf(OCCASION_TAGS, slug) !== -1) return 'occasion';
    if (indexOf(THEME_GROUP_TAGS, slug) !== -1 || indexOf(THEME_SUB_TAGS, slug) !== -1) return 'theme';
    if (indexOf(FEATURE_TAGS, slug) !== -1)  return 'features';
    if (indexOf(MATERIAL_TAGS, slug) !== -1) return 'material';
    if (indexOf(SIZE_TAGS, slug) !== -1)     return 'size';
    return 'sub';
  }

  function activeKeysFor(candidate) {
    var cat  = categoryOf(candidate);
    var base = getBaseTags();
    var keys = [];
    for (var i = 0; i < base.length; i++) {
      var at = base[i];
      if (at === candidate) continue;
      if (cat !== 'sub' && categoryOf(at) === cat) continue;
      keys.push(at);
    }
    keys.push(candidate);
    return keys;
  }

  function getCount(tag) {
    if (!counts) return null;

    if (indexCol()) {
      return comboCount(activeKeysFor(tag));
    }

    var col = counts[collectionHandle];
    if (colTagsReady && col) {
      var v = lookupCount(col.tags, tag);
      if (v !== null) return v;
    }
    return lookupCount(counts.global && counts.global.tags, tag);
  }

  function getVendorCount(vendor) {
    if (!counts) return null;

    var vTag = null;
    for (var k = 0; k < VENDORS.length; k++) {
      if (VENDORS[k].value === vendor) { vTag = VENDORS[k].tag; break; }
    }

    if (indexCol() && vTag) {
      return comboCount(activeKeysFor(vTag));
    }

    var col = counts[collectionHandle];
    if (colVendorsReady && col) {
      var v = lookupCount(col.vendors, vendor);
      if (v !== null) return v;
    }
    return lookupCount(counts.global && counts.global.vendors, vendor);
  }

  function getTypeCount(handle) {
    if (!counts) return null;
    return lookupCount(counts.global && counts.global.types, handle);
  }

  /* ── Whole-filter visibility ──────────────────────────────────
     A dropdown can end up with EVERY option hidden (all zero-count,
     none active) after the counts load — e.g. "Size" on a collection
     where no product in the current filter context has a size tag.
     In that case the button itself should disappear instead of
     opening to reveal an empty box. Returns true (don't hide) until
     counts have actually loaded, matching the same "don't guess
     before we know" behavior as individual option hiding. */
  function hasVisibleOptions(filterId) {
    if (!counts) return true;
    var i, isActive;
    switch (filterId) {
      case 'type':
        for (i = 0; i < PRODUCT_TYPES.length; i++) {
          if (getTypeCount(PRODUCT_TYPES[i].handle) !== 0 || displayHandle === PRODUCT_TYPES[i].handle) return true;
        }
        return false;
      case 'brand':
        for (i = 0; i < VENDORS.length; i++) {
          isActive = indexOf(activeTags, VENDORS[i].tag) !== -1;
          if (getVendorCount(VENDORS[i].value) !== 0 || isActive) return true;
        }
        return false;
      case 'season':
        for (i = 0; i < SEASONS.length; i++) {
          isActive = (indexOf(activeTags, SEASONS[i].tag) !== -1) || tagParamActive(SEASONS[i].tag);
          if (getCount(SEASONS[i].tag) !== 0 || isActive) return true;
        }
        return false;
      case 'holiday': {
        var activeSeason = null;
        for (var k = 0; k < activeTags.length; k++) {
          if (indexOf(SEASON_TAGS, activeTags[k]) !== -1) { activeSeason = activeTags[k]; break; }
        }
        if (!activeSeason) {
          for (var sp = 0; sp < activeTagParams.length; sp++) {
            if (indexOf(SEASON_TAGS, activeTagParams[sp]) !== -1) { activeSeason = activeTagParams[sp]; break; }
          }
        }
        for (i = 0; i < HOLIDAYS.length; i++) {
          if (activeSeason && indexOf(HOLIDAYS[i].seasons, activeSeason) === -1) continue;
          isActive = (indexOf(activeTags, HOLIDAYS[i].tag) !== -1) || tagParamActive(HOLIDAYS[i].tag);
          if (getCount(HOLIDAYS[i].tag) !== 0 || isActive) return true;
        }
        return false;
      }
      case 'occasion':
        for (i = 0; i < OCCASIONS.length; i++) {
          isActive = (indexOf(activeTags, OCCASIONS[i].tag) !== -1) || tagParamActive(OCCASIONS[i].tag);
          if (getCount(OCCASIONS[i].tag) !== 0 || isActive) return true;
        }
        return false;
      case 'theme':
        for (i = 0; i < THEMES.length; i++) {
          var grp = THEMES[i];
          var grpActive = (indexOf(activeTags, grp.groupTag) !== -1) || tagParamActive(grp.groupTag);
          if (getCount(grp.groupTag) !== 0 || grpActive) return true;
          for (var j = 0; j < grp.items.length; j++) {
            isActive = (indexOf(activeTags, grp.items[j].tag) !== -1) || tagParamActive(grp.items[j].tag);
            if (getCount(grp.items[j].tag) !== 0 || isActive) return true;
          }
        }
        return false;
      case 'features':
        for (i = 0; i < FEATURES.length; i++) {
          isActive = indexOf(activeTags, FEATURES[i].tag) !== -1;
          if (getCount(FEATURES[i].tag) !== 0 || isActive) return true;
        }
        return false;
      case 'material':
        return hasVisibleSubGroup('Material');
      case 'size':
        return hasVisibleSubGroup('Size');
      default:
        return true;
    }
  }

  function hasVisibleSubGroup(groupLabel) {
    var defs = SUB_FILTERS[displayHandle];
    if (!defs) return false;
    for (var i = 0; i < defs.length; i++) {
      if (defs[i].label !== groupLabel) continue;
      var opts = defs[i].options;
      for (var j = 0; j < opts.length; j++) {
        var isActive = indexOf(activeTags, opts[j].tag) !== -1;
        if (getCount(opts[j].tag) !== 0 || isActive) return true;
      }
    }
    return false;
  }

  /* Re-check every dropdown's whole-button visibility. Called once counts
     have loaded (and are therefore trustworthy). Material/Size are also
     gated by whether the collection defines that sub-filter at all
     (renderSubFilters) — both conditions must pass for the button to show. */
  function updateAllGroupVisibility() {
    var simple = ['season', 'holiday', 'occasion', 'theme', 'features', 'brand', 'type'];
    for (var i = 0; i < simple.length; i++) {
      showFilterGroup(simple[i], hasVisibleOptions(simple[i]));
    }

    var defs = SUB_FILTERS[displayHandle] || [];
    var hasMatDef = false, hasSizeDef = false;
    for (var d = 0; d < defs.length; d++) {
      if (defs[d].label === 'Material') hasMatDef = true;
      if (defs[d].label === 'Size')     hasSizeDef = true;
    }
    showFilterGroup('material', hasMatDef  && hasVisibleOptions('material'));
    showFilterGroup('size',     hasSizeDef && hasVisibleOptions('size'));
  }

  function initDropdownTriggers() {
    var groups = mainRow.querySelectorAll('.filter-bar-group[data-filter]');
    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        var btn      = group.querySelector('.filter-bar-btn');
        var filterId = group.getAttribute('data-filter');
        if (!btn || !filterId) return;
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = (btn.getAttribute('aria-expanded') === 'true');
          closeAllDropdowns();
          if (!isOpen) openDropdown(filterId);
        });
      })(groups[i]);
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        clearAllFilters();
      });
    }
  }

  function openDropdown(filterId) {
    var btn = document.getElementById('fb-btn-' + filterId);
    var dd  = document.getElementById('fb-dropdown-' + filterId);
    if (!btn || !dd) return;

    buildDropdown(filterId);

    var rect   = btn.getBoundingClientRect();
    var topPos = rect.bottom + 4;

    dd.style.top   = topPos + 'px';
    dd.style.left  = rect.left + 'px';
    dd.style.right = 'auto';

    dd.removeAttribute('hidden');
    btn.setAttribute('aria-expanded', 'true');

    var ddW = dd.offsetWidth;
    if (rect.left + ddW > window.innerWidth - 12) {
      var adjusted = rect.right - ddW;
      dd.style.left = Math.max(8, adjusted) + 'px';
    }

    setTimeout(function () {
      var first = dd.querySelector('.filter-bar-option') || dd.querySelector('.filter-bar-theme-header--clickable');
      if (first) first.focus();
    }, 40);
  }

  function closeAllDropdowns() {
    var btns = document.querySelectorAll('.filter-bar-btn[aria-expanded="true"]');
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-expanded', 'false');
    var dds = document.querySelectorAll('.filter-bar-dropdown:not([hidden])');
    for (var j = 0; j < dds.length; j++) {
      dds[j].setAttribute('hidden', '');
      dds[j].style.top  = '';
      dds[j].style.left = '';
    }
  }

  function buildDropdown(filterId) {
    var dd = document.getElementById('fb-dropdown-' + filterId);
    if (!dd) return;
    dd.innerHTML = '';
    switch (filterId) {
      case 'type':     buildTypeDropdown(dd);     break;
      case 'brand':    buildBrandDropdown(dd);    break;
      case 'season':   buildSeasonDropdown(dd);   break;
      case 'holiday':  buildHolidayDropdown(dd);  break;
      case 'occasion': buildOccasionDropdown(dd); break;
      case 'theme':    buildThemeDropdown(dd);    break;
      case 'features': buildFeaturesDropdown(dd); break;
      case 'material': buildSubGroupDropdown(dd, 'Material', 'material'); break;
      case 'size':     buildSubGroupDropdown(dd, 'Size',     'size');     break;
    }
    /* Every builder above hid its zero-result options; if that leaves the
       whole panel empty, show a message instead of a blank white box. */
    if (dd.childElementCount === 0) {
      var empty = document.createElement('div');
      empty.className = 'filter-bar-empty';
      empty.textContent = 'No matching options';
      dd.appendChild(empty);
    }
  }

  /* Append an option node to a container, but only if it isn't null.
     makeOption() returns null for zero-result options that aren't
     already active — this is where "hide instead of grey out" actually
     takes effect at every call site. */
  function appendOpt(container, node) {
    if (node) container.appendChild(node);
  }

  function buildSubGroupDropdown(dd, groupLabel, category) {
    var defs = SUB_FILTERS[displayHandle];
    if (!defs) return;
    for (var i = 0; i < defs.length; i++) {
      if (defs[i].label !== groupLabel) continue;
      var opts = defs[i].options;
      for (var j = 0; j < opts.length; j++) {
        var opt      = opts[j];
        var isActive = (indexOf(activeTags, opt.tag) !== -1);
        var count    = getCount(opt.tag);
        appendOpt(dd, makeOption(opt.label, isActive, count, (function (tag) {
          return function () { toggleTag(tag, category); };
        })(opt.tag)));
      }
    }
  }

  /* Returns null (renders nothing) for a zero-result option that isn't
     already selected — this HIDES it instead of the old
     strikethrough/greyed-out treatment. An already-active option with a
     zero count still renders (with its badge) so it can always be
     clicked again to deselect. */
  function makeOption(label, isActive, count, onClick) {
    if (count === 0 && !isActive) return null;

    var btn = document.createElement('button');
    btn.className = 'filter-bar-option';
    btn.setAttribute('type', 'button');
    btn.setAttribute('role', 'option');
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    if (isActive) btn.classList.add('is-active');

    var span = document.createElement('span');
    span.textContent = label;
    btn.appendChild(span);

    if (count !== null && count !== undefined) {
      var badge = document.createElement('span');
      badge.className = 'filter-bar-count';
      badge.textContent = count;
      btn.appendChild(badge);
    }

    if (typeof onClick === 'function') {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        onClick();
      });
    }
    return btn;
  }

  function buildTypeDropdown(dd) {
    for (var i = 0; i < PRODUCT_TYPES.length; i++) {
      var pt      = PRODUCT_TYPES[i];
      var isActive = (displayHandle === pt.handle);
      var count    = getTypeCount(pt.handle);
      appendOpt(dd, makeOption(pt.label, isActive, count, (function (handle) {
        return function () { navigateToType(handle); };
      })(pt.handle)));
    }
  }

  function buildBrandDropdown(dd) {
    for (var i = 0; i < VENDORS.length; i++) {
      var v       = VENDORS[i];
      var isActive = (indexOf(activeTags, v.tag) !== -1);
      var count    = getVendorCount(v.value);
      appendOpt(dd, makeOption(v.label, isActive, count, (function (tag) {
        return function () { toggleVendor(tag); };
      })(v.tag)));
    }
  }

  function buildSeasonDropdown(dd) {
    for (var i = 0; i < SEASONS.length; i++) {
      var s       = SEASONS[i];
      var isActive = (indexOf(activeTags, s.tag) !== -1) || tagParamActive(s.tag);
      var count    = getCount(s.tag);
      appendOpt(dd, makeOption(s.label, isActive, count, (function (tag) {
        return function () { toggleTag(tag, 'season'); };
      })(s.tag)));
    }
  }

  function buildHolidayDropdown(dd) {
    var activeSeason = null;
    for (var k = 0; k < activeTags.length; k++) {
      if (indexOf(SEASON_TAGS, activeTags[k]) !== -1) {
        activeSeason = activeTags[k];
        break;
      }
    }
    if (!activeSeason) {
      for (var sp = 0; sp < activeTagParams.length; sp++) {
        if (indexOf(SEASON_TAGS, activeTagParams[sp]) !== -1) { activeSeason = activeTagParams[sp]; break; }
      }
    }
    for (var i = 0; i < HOLIDAYS.length; i++) {
      var h = HOLIDAYS[i];
      if (activeSeason && indexOf(h.seasons, activeSeason) === -1) continue;
      var isActive = (indexOf(activeTags, h.tag) !== -1) || tagParamActive(h.tag);
      var count    = getCount(h.tag);
      appendOpt(dd, makeOption(h.label, isActive, count, (function (tag) {
        return function () { toggleTag(tag, 'holiday'); };
      })(h.tag)));
    }
  }

  function buildOccasionDropdown(dd) {
    for (var i = 0; i < OCCASIONS.length; i++) {
      var o       = OCCASIONS[i];
      var isActive = (indexOf(activeTags, o.tag) !== -1) || tagParamActive(o.tag);
      var count    = getCount(o.tag);
      appendOpt(dd, makeOption(o.label, isActive, count, (function (tag) {
        return function () { toggleTag(tag, 'occasion'); };
      })(o.tag)));
    }
  }

  function buildThemeDropdown(dd) {
    var grid = document.createElement('div');
    grid.className = 'filter-bar-theme-grid';

    for (var i = 0; i < THEMES.length; i++) {
      var grp       = THEMES[i];
      var grpActive = (indexOf(activeTags, grp.groupTag) !== -1) || tagParamActive(grp.groupTag);
      var grpCount  = getCount(grp.groupTag);

      if (grp.items.length === 0) {
        /* Standalone group — header IS the clickable option. Skip entirely
           when it has zero results and isn't active. */
        if (grpCount === 0 && !grpActive) continue;

        var hdr = document.createElement('button');
        hdr.className = 'filter-bar-theme-header filter-bar-theme-header--clickable';
        hdr.setAttribute('type', 'button');
        hdr.setAttribute('role', 'option');
        hdr.setAttribute('aria-selected', grpActive ? 'true' : 'false');
        if (grpActive) hdr.classList.add('is-active');

        var hLabel = document.createElement('span');
        hLabel.textContent = grp.group;
        hdr.appendChild(hLabel);

        if (grpCount !== null) {
          var hBadge = document.createElement('span');
          hBadge.className = 'filter-bar-count';
          hBadge.textContent = grpCount;
          hdr.appendChild(hBadge);
        }

        hdr.addEventListener('click', (function (tag) {
          return function (e) { e.stopPropagation(); toggleTag(tag, 'theme'); };
        })(grp.groupTag));
        grid.appendChild(hdr);
      } else {
        /* Group with sub-items — build item nodes first; if every item in
           the group is hidden (zero results, none active), skip the whole
           group including its header so there's never an orphan section
           label with nothing under it. */
        var itemNodes = [];
        for (var j = 0; j < grp.items.length; j++) {
          var item     = grp.items[j];
          var isActive = (indexOf(activeTags, item.tag) !== -1) || tagParamActive(item.tag);
          var count    = getCount(item.tag);
          var node = makeOption(item.label, isActive, count, (function (tag) {
            return function () { toggleTag(tag, 'theme'); };
          })(item.tag));
          if (node) itemNodes.push(node);
        }
        if (itemNodes.length === 0) continue;

        var groupHdr = document.createElement('button');
        groupHdr.className = 'filter-bar-theme-header filter-bar-theme-header--clickable';
        groupHdr.setAttribute('type', 'button');
        groupHdr.setAttribute('role', 'option');
        groupHdr.setAttribute('aria-selected', grpActive ? 'true' : 'false');
        if (grpActive) groupHdr.classList.add('is-active');

        var gLabel = document.createElement('span');
        gLabel.textContent = grp.group;
        groupHdr.appendChild(gLabel);

        if (grpCount !== null) {
          var gBadge = document.createElement('span');
          gBadge.className = 'filter-bar-count';
          gBadge.textContent = grpCount;
          groupHdr.appendChild(gBadge);
        }

        groupHdr.addEventListener('click', (function (tag) {
          return function (e) { e.stopPropagation(); toggleTag(tag, 'theme'); };
        })(grp.groupTag));
        grid.appendChild(groupHdr);

        for (var ni = 0; ni < itemNodes.length; ni++) grid.appendChild(itemNodes[ni]);
      }
    }

    if (grid.childElementCount > 0) dd.appendChild(grid);
  }

  function buildFeaturesDropdown(dd) {
    for (var i = 0; i < FEATURES.length; i++) {
      var f       = FEATURES[i];
      var isActive = (indexOf(activeTags, f.tag) !== -1);
      var count    = getCount(f.tag);
      appendOpt(dd, makeOption(f.label, isActive, count, (function (tag) {
        return function () { toggleTag(tag, 'features'); };
      })(f.tag)));
    }
  }

  function patchPaginationLinks() {
    var needsType     = !!(activeType && displayHandle !== collectionHandle);
    var needsTag      = activeTagParams.length > 0;
    var needsPathTags = activeTags.length > 0;
    if (!needsType && !needsTag && !needsPathTags) return;
    var wrap = document.querySelector('.pagination-wrap');
    if (!wrap) return;
    var links = wrap.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;

      if (needsPathTags) {
        var qIdx    = href.indexOf('?');
        var pathStr = qIdx !== -1 ? href.substring(0, qIdx) : href;
        var qStr    = qIdx !== -1 ? href.substring(qIdx) : '';
        if (/\/collections\/[^\/]+$/.test(pathStr)) {
          pathStr = pathStr + '/' + activeTags.join('+');
          href = pathStr + qStr;
        }
      }

      if (needsType && href.indexOf('type=') === -1) {
        href += (href.indexOf('?') !== -1 ? '&' : '?') + 'type=' + encodeURIComponent(activeType);
      }
      if (needsTag && href.indexOf('tag=') === -1) {
        href += (href.indexOf('?') !== -1 ? '&' : '?') + 'tag=' + encodeURIComponent(activeTagParams.join(','));
      }
      links[i].setAttribute('href', href);
    }
  }

  function renderSubFilters() {
    if (subRow) subRow.setAttribute('hidden', '');

    var defs   = SUB_FILTERS[displayHandle] || [];
    var hasMat = false, hasSize = false;
    for (var i = 0; i < defs.length; i++) {
      if (defs[i].label === 'Material') hasMat = true;
      if (defs[i].label === 'Size')     hasSize = true;
    }
    showFilterGroup('material', hasMat);
    showFilterGroup('size',     hasSize);
  }

  function showFilterGroup(filterId, show) {
    var group = mainRow ? mainRow.querySelector('.filter-bar-group[data-filter="' + filterId + '"]') : null;
    if (!group) return;
    if (show) group.removeAttribute('hidden');
    else      group.setAttribute('hidden', '');
  }

  function updateButtonStates() {
    updateFilterBtnState('season',   function (t) { return indexOf(SEASON_TAGS, t) !== -1; });
    updateFilterBtnState('holiday',  function (t) { return indexOf(HOLIDAY_TAGS, t) !== -1; });
    updateFilterBtnState('occasion', function (t) { return indexOf(OCCASION_TAGS, t) !== -1; });
    updateFilterBtnState('theme',    function (t) {
      return indexOf(THEME_GROUP_TAGS, t) !== -1 || indexOf(THEME_SUB_TAGS, t) !== -1;
    });
    updateFilterBtnState('features', function (t) { return indexOf(FEATURE_TAGS, t) !== -1; });
    updateFilterBtnState('material', function (t) { return indexOf(MATERIAL_TAGS, t) !== -1; });
    updateFilterBtnState('size',     function (t) { return indexOf(SIZE_TAGS, t) !== -1; });

    if (activeType && displayHandle !== collectionHandle) {
      var typeBtn = document.getElementById('fb-btn-type');
      if (typeBtn) {
        typeBtn.classList.add('filter-bar-btn--active');
        var typeLblEl = typeBtn.querySelector('.filter-bar-btn-label');
        var typeLabelStr = getTypeLabel(activeType);
        if (typeLblEl && typeLabelStr) typeLblEl.textContent = typeLabelStr;
      }
    }

    var brandBtn = document.getElementById('fb-btn-brand');
    if (brandBtn) {
      if (activeVendor) {
        brandBtn.classList.add('filter-bar-btn--active');
        var lbl = brandBtn.querySelector('.filter-bar-btn-label');
        if (lbl) lbl.textContent = activeVendor;
      }
    }

    for (var tpi = 0; tpi < activeTagParams.length; tpi++) {
      var tp = activeTagParams[tpi];
      var tagBtnId = getTagBtnId(tp);
      if (!tagBtnId) continue;
      var tagBtn = document.getElementById('fb-btn-' + tagBtnId);
      if (!tagBtn) continue;
      tagBtn.classList.add('filter-bar-btn--active');
      var tagLabelStr = getTagLabel(tp);
      if (tagLabelStr) {
        var tagLblEl = tagBtn.querySelector('.filter-bar-btn-label');
        if (tagLblEl) tagLblEl.textContent = tagLabelStr;
      }
    }

    setActiveLabelInBtn('season',   SEASONS,   function (t) { return indexOf(SEASON_TAGS, t) !== -1; });
    setActiveLabelInBtn('holiday',  HOLIDAYS,  function (t) { return indexOf(HOLIDAY_TAGS, t) !== -1; });
    setActiveLabelInBtn('occasion', OCCASIONS, function (t) { return indexOf(OCCASION_TAGS, t) !== -1; });
    setActiveLabelInBtn('features', FEATURES,  function (t) { return indexOf(FEATURE_TAGS, t) !== -1; });
    setActiveLabelInBtn('material', MATERIAL_OPTS, function (t) { return indexOf(MATERIAL_TAGS, t) !== -1; });
    setActiveLabelInBtn('size',     SIZE_OPTS,     function (t) { return indexOf(SIZE_TAGS, t) !== -1; });
    setThemeLabelInBtn();
  }

  function updateFilterBtnState(filterId, tester) {
    var btn    = document.getElementById('fb-btn-' + filterId);
    if (!btn) return;
    var hasActive = false;
    for (var i = 0; i < activeTags.length; i++) {
      if (tester(activeTags[i])) { hasActive = true; break; }
    }
    if (hasActive) btn.classList.add('filter-bar-btn--active');
    else           btn.classList.remove('filter-bar-btn--active');
  }

  function setActiveLabelInBtn(filterId, list, tester) {
    var btn = document.getElementById('fb-btn-' + filterId);
    if (!btn) return;
    for (var i = 0; i < activeTags.length; i++) {
      if (!tester(activeTags[i])) continue;
      for (var j = 0; j < list.length; j++) {
        if (list[j].tag === activeTags[i]) {
          var lbl = btn.querySelector('.filter-bar-btn-label');
          if (lbl) lbl.textContent = list[j].label;
          return;
        }
      }
    }
  }

  function setThemeLabelInBtn() {
    var btn = document.getElementById('fb-btn-theme');
    if (!btn) return;
    for (var i = 0; i < activeTags.length; i++) {
      var tag = activeTags[i];
      for (var g = 0; g < THEMES.length; g++) {
        if (THEMES[g].groupTag === tag) {
          var lbl = btn.querySelector('.filter-bar-btn-label');
          if (lbl) lbl.textContent = THEMES[g].group;
          return;
        }
        for (var k = 0; k < THEMES[g].items.length; k++) {
          if (THEMES[g].items[k].tag === tag) {
            var lbl2 = btn.querySelector('.filter-bar-btn-label');
            if (lbl2) lbl2.textContent = THEMES[g].items[k].label;
            return;
          }
        }
      }
    }
  }

  function navigateToType(handle) {
    var tags = getBaseTags().filter(function (t) {
      return indexOf(SEASON_TAGS, t) !== -1 ||
             indexOf(HOLIDAY_TAGS, t) !== -1 ||
             indexOf(OCCASION_TAGS, t) !== -1 ||
             indexOf(THEME_GROUP_TAGS, t) !== -1 ||
             indexOf(THEME_SUB_TAGS, t) !== -1 ||
             indexOf(FEATURE_TAGS, t) !== -1 ||
             indexOf(VENDOR_TAGS, t) !== -1;
    });
    window.location.href = buildUrl('/collections/' + handle, tags);
  }

  function toggleTag(tag, category) {
    closeAllDropdowns();
    var tagLow = tag.toLowerCase();
    var base   = getBaseTags();
    var idx    = indexOf(base, tagLow);
    var newTags;
    if (idx !== -1) {
      newTags = base.filter(function (t) { return t !== tagLow; });
    } else {
      if (category !== 'sub') {
        newTags = base.filter(function (t) { return !isTagInCategory(t, category); });
      } else {
        newTags = base.slice();
      }
      newTags.push(tagLow);
    }
    window.location.href = buildUrl('/collections/' + displayHandle, newTags);
  }

  function toggleVendor(vendorTag) {
    closeAllDropdowns();
    var base = getBaseTags();
    var newTags = base.filter(function (t) { return indexOf(VENDOR_TAGS, t) === -1; });
    if (indexOf(base, vendorTag) === -1) newTags.push(vendorTag);
    window.location.href = buildUrl('/collections/' + displayHandle, newTags);
  }

  function clearAllFilters() {
    window.location.href = '/collections/' + displayHandle;
  }

  function isTagInCategory(tag, category) {
    switch (category) {
      case 'season':   return indexOf(SEASON_TAGS, tag) !== -1;
      case 'holiday':  return indexOf(HOLIDAY_TAGS, tag) !== -1;
      case 'occasion': return indexOf(OCCASION_TAGS, tag) !== -1;
      case 'theme':    return indexOf(THEME_GROUP_TAGS, tag) !== -1 || indexOf(THEME_SUB_TAGS, tag) !== -1;
      case 'features': return indexOf(FEATURE_TAGS, tag) !== -1;
      case 'material': return indexOf(MATERIAL_TAGS, tag) !== -1;
      case 'size':     return indexOf(SIZE_TAGS, tag) !== -1;
      default:         return false;
    }
  }

  function buildUrl(base, tags) {
    var url = base;
    if (tags && tags.length > 0) url += '/' + tags.join('+');
    return url;
  }

  function renderPills() {
    if (!pillsEl) return;
    pillsEl.innerHTML = '';
    var hasAny = false;

    var typeLabel = getTypeLabel(displayHandle);
    if (typeLabel) {
      addPill(typeLabel, 'type', null);
      hasAny = true;
    }

    for (var i = 0; i < activeTags.length; i++) {
      addPill(getTagLabel(activeTags[i]), 'tag', activeTags[i]);
      hasAny = true;
    }

    for (var tpi = 0; tpi < activeTagParams.length; tpi++) {
      var tparam = activeTagParams[tpi];
      if (indexOf(activeTags, tparam) !== -1) continue;
      var tagParamLabel = getTagLabel(tparam);
      if (tagParamLabel) {
        addPill(tagParamLabel, 'tag-param', tparam);
        hasAny = true;
      }
    }

    if (pillsRow) {
      if (hasAny) pillsRow.removeAttribute('hidden');
      else        pillsRow.setAttribute('hidden', '');
    }
  }

  function addPill(label, type, tag) {
    var pill = document.createElement('div');
    pill.className = 'filter-bar-pill';
    pill.setAttribute('role', 'listitem');

    var text = document.createElement('span');
    text.textContent = label;
    pill.appendChild(text);

    var rm = document.createElement('button');
    rm.className = 'filter-bar-pill-remove';
    rm.setAttribute('type', 'button');
    rm.setAttribute('aria-label', 'Remove ' + label + ' filter');
    rm.innerHTML = '&times;';
    rm.addEventListener('click', (function (t, tp, tg) {
      return function (e) {
        e.stopPropagation();
        if (tp === 'tag' && tg) {
          var newTags = getBaseTags().filter(function (x) { return x !== tg; });
          window.location.href = buildUrl('/collections/' + displayHandle, newTags);
        } else if (tp === 'tag-param') {
          var keep = getBaseTags().filter(function (x) { return x !== tg; });
          window.location.href = buildUrl('/collections/' + displayHandle, keep);
        } else if (tp === 'type') {
          window.location.href = buildUrl('/collections/all', activeTags);
        }
      };
    })(label, type, tag));

    pill.appendChild(rm);
    pillsEl.appendChild(pill);
  }

  function updateClearBtn() {
    if (!clearBtn) return;
    if (activeTags.length > 0 || activeTagParams.length > 0) clearBtn.removeAttribute('hidden');
    else clearBtn.setAttribute('hidden', '');
  }

  function initStickyObserver() {
    if (!window.IntersectionObserver || !bar) return;
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;';
    bar.parentNode.insertBefore(sentinel, bar);
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: [1] }).observe(sentinel);
  }

  function onDocKeydown(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      return;
    }
    var openDd = document.querySelector('.filter-bar-dropdown:not([hidden])');
    if (!openDd) return;
    var options = openDd.querySelectorAll('.filter-bar-option, .filter-bar-theme-header--clickable');
    var focused = document.activeElement;
    var idx     = -1;
    for (var i = 0; i < options.length; i++) {
      if (options[i] === focused) { idx = i; break; }
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = options[idx + 1] || options[0];
      if (next) next.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      var prev = options[idx - 1] || options[options.length - 1];
      if (prev) prev.focus();
    } else if (e.key === 'Tab') {
      closeAllDropdowns();
    }
  }

  function onDocClick() {
    closeAllDropdowns();
  }

  function indexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) { if (arr[i] === val) return i; }
    return -1;
  }

  function slugify(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function getUrlParam(name) {
    var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
  }

  function getTypeLabel(handle) {
    for (var i = 0; i < PRODUCT_TYPES.length; i++) {
      if (PRODUCT_TYPES[i].handle === handle) return PRODUCT_TYPES[i].label;
    }
    return null;
  }

  function getTagLabel(tag) {
    for (var vi = 0; vi < VENDORS.length; vi++) {
      if (VENDORS[vi].tag === tag) return VENDORS[vi].label;
    }
    var lists = [SEASONS, HOLIDAYS, OCCASIONS, FEATURES];
    for (var l = 0; l < lists.length; l++) {
      for (var i = 0; i < lists[l].length; i++) {
        if (lists[l][i].tag === tag) return lists[l][i].label;
      }
    }
    for (var g = 0; g < THEMES.length; g++) {
      if (THEMES[g].groupTag === tag) return THEMES[g].group;
      for (var k = 0; k < THEMES[g].items.length; k++) {
        if (THEMES[g].items[k].tag === tag) return THEMES[g].items[k].label;
      }
    }
    for (var handle in SUB_FILTERS) {
      var groups = SUB_FILTERS[handle];
      for (var gi = 0; gi < groups.length; gi++) {
        for (var oi = 0; oi < groups[gi].options.length; oi++) {
          if (groups[gi].options[oi].tag === tag) return groups[gi].options[oi].label;
        }
      }
    }
    return tag;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();